// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__Lei2H","isHiddenTile":"Tile_isHiddenTile__YbzEh","inner":"Tile_inner__nv-RK","number":"Tile_number__TS3fq"};